// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1k-3b","boxTitle":"Qualiphy_boxTitle__3_F-a","box":"Qualiphy_box__1A8DO","toggleWrap":"Qualiphy_toggleWrap__3b6UW"};